const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

function getNextDate(dayOfWeek) {
  const targetDay = daysOfWeek.indexOf(dayOfWeek);

  if (targetDay < 0) return null;

  const date = new Date();
  const diff = (targetDay - date.getDay() + 7) % 7;
  date.setDate(date.getDate() + diff);

  return date;
}

const formatTime = (hour, minute) => {
  const period = hour < 12 ? 'AM' : 'PM';
  let adjustedHour = hour;

  if (adjustedHour === 0) adjustedHour = 12;
  else if (adjustedHour > 12) adjustedHour -= 12;

  const minuteFormatted = minute < 10 ? `0${minute}` : minute;

  return `${adjustedHour}:${minuteFormatted} ${period}`;
};

const formatDateString = date => (typeof date === 'string' ? `${date}T00:00:00.000` : date);

export default { getNextDate, formatTime, formatDateString };
